const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then((vitals) => {
      if (vitals.onCLS) {
        // web-vitals v3 / v4 API
        vitals.onCLS(onPerfEntry);
        if (vitals.onFCP) vitals.onFCP(onPerfEntry);
        if (vitals.onLCP) vitals.onLCP(onPerfEntry);
        if (vitals.onTTFB) vitals.onTTFB(onPerfEntry);
        if (vitals.onINP) vitals.onINP(onPerfEntry);
      } else if (vitals.getCLS) {
        // web-vitals v2 API
        vitals.getCLS(onPerfEntry);
        if (vitals.getFID) vitals.getFID(onPerfEntry);
        if (vitals.getFCP) vitals.getFCP(onPerfEntry);
        if (vitals.getLCP) vitals.getLCP(onPerfEntry);
        if (vitals.getTTFB) vitals.getTTFB(onPerfEntry);
      }
    }).catch(() => {
      // Ignore if web-vitals import fails
    });
  }
};

export default reportWebVitals;
